module.exports = __webpack_public_path__ + "img/usgbc-logo.08576a85.svg";